import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Download, RotateCcw } from 'lucide-react';
import { CTAButton } from './CTAButton';
const items = [{
  name: '💊 Guía Completa 45+ páginas',
  price: '$29.99'
}, {
  name: '📅 Calendarios 3 meses imprimibles',
  price: '$9.99'
}, {
  name: '✅ Mega-Checklists 4 tipos',
  price: '$7.99'
}, {
  name: '🚨 Árbol de Decisión Visual',
  price: '$5.99'
}, {
  name: '💳 Tarjeta de Emergencia Recortable',
  price: '$4.99'
}, {
  name: '📊 Tracker de Síntomas 6 Meses',
  price: '$6.99'
}, {
  name: '🏆 Sistema de Recompensas y Rachas',
  price: '$4.99'
}];
export function ValueStack() {
  const scrollToCTA = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-302">
      <div className="text-center mb-12" data-id="element-303">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-304">
          Todo lo que recibes hoy:
        </h2>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-white rounded-[24px] p-8 md:p-12 shadow-xl border-2 border-brand-primary/20" data-id="element-305">
        <div className="space-y-4 mb-8" data-id="element-306">
          {items.map((item, index) => <div key={index} className="flex items-center justify-between border-b border-gray-100 pb-4 last:border-0" data-id="element-307">
              <div className="flex items-center gap-3" data-id="element-308">
                <Check className="w-5 h-5 text-brand-success shrink-0" data-id="element-309" />
                <span className="text-lg text-brand-dark font-medium" data-id="element-310">
                  {item.name}
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-311">
                <div className="hidden sm:block flex-grow border-b border-dotted border-gray-300 mx-4" data-id="element-312"></div>
                <span className="text-gray-400 line-through font-medium" data-id="element-313">
                  {item.price}
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-bg rounded-[16px] p-6 md:p-8 text-center mb-8 border border-brand-cardPink" data-id="element-314">
          <p className="text-lg text-brand-secondary mb-2" data-id="element-315">
            Valor total: <span className="line-through" data-id="element-316">$70.93</span>
          </p>
          <p className="text-xl text-brand-dark font-medium mb-4" data-id="element-317">
            Precio normal:{' '}
            <span className="line-through text-gray-400" data-id="element-318">$19.99</span>
          </p>
          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-sm mb-2 border border-brand-cardPurple" data-id="element-319">
            <p className="text-3xl md:text-4xl font-bold text-brand-accent" data-id="element-320">
              🔥 HOY PAGAS SOLO: $11.99
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-321">
          <CTAButton className="w-full sm:w-auto mb-6 text-xl py-5 px-10" data-id="element-322">
            💊 QUIERO TODO ESTO POR SOLO $11.99
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-brand-secondary font-medium" data-id="element-323">
            <span className="flex items-center gap-1" data-id="element-324">
              <Lock className="w-4 h-4" data-id="element-325" /> Pago seguro
            </span>
            <span className="hidden sm:inline text-brand-cardPink" data-id="element-326">•</span>
            <span className="flex items-center gap-1" data-id="element-327">
              <Download className="w-4 h-4" data-id="element-328" /> Descarga inmediata
            </span>
            <span className="hidden sm:inline text-brand-cardPink" data-id="element-329">•</span>
            <span className="flex items-center gap-1" data-id="element-330">
              <RotateCcw className="w-4 h-4" data-id="element-331" /> Garantía 7 días
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}